<main class="mds-grid mds-grid-cols-1">
  <mc-card heading="Callback" subheading="Token response">
    <div>
      <div class="mds-flex mds-flex-row mds-gap-200 mds-flex-items-center">
        <mc-icon [icon]="errorVisible() ? 'times-circle' : 'check-circle'" [color]="errorVisible() ? 'red' : 'green'"></mc-icon>
        <span>{{ statusText() }}</span>
      </div>

      @if (tokenPanelVisible()) {
      <mc-accordion expandiconposition="left">
        @if (idTokenRaw()) {
        <mc-accordion-item heading="ID token">
          <div slot="body" class="mds-flex mds-flex-column mds-gap-200">
            <app-code-block [content]="idTokenRaw()"></app-code-block>
          </div>
        </mc-accordion-item>
        }

        @if (accessTokenRaw()) {
        <mc-accordion-item heading="Access token">
          <div slot="body" class="mds-flex mds-flex-column mds-gap-200">
            <app-code-block [content]="accessTokenDecoded()"></app-code-block>
            <app-code-block [content]="accessTokenRaw()"></app-code-block>
          </div>
        </mc-accordion-item>
        }


        @if (refreshTokenRaw()) {
        <mc-accordion-item heading="Refresh token">
          <div slot="body" class="mds-flex mds-flex-column mds-gap-200">
            <app-code-block [content]="refreshTokenRaw()"></app-code-block>
          </div>
        </mc-accordion-item>
        }

        <mc-accordion-item heading="User profile" expanded>
          <div slot="body" class="mds-flex mds-flex-column mds-gap-200">
            <app-code-block [content]="profileData()"></app-code-block>
          </div>
        </mc-accordion-item>
      </mc-accordion>
      }

      @if (errorVisible()) {
      <app-code-block [content]="errorMessage()"></app-code-block>
      }
    </div>

    <mc-button [hidden]="errorVisible()" slot="actions" appearance="neutral" trailingicon="door-arrow-right" (click)="signOut()">Sign out</mc-button>
    <mc-button [hidden]="!errorVisible()" slot="actions" appearance="neutral" icon="arrow-curved-up-left" routerLink="/">Back to login</mc-button>
  </mc-card>
</main>